import {Grid, Typography, withStyles} from '@material-ui/core'
import {Visibility} from '@material-ui/icons'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import CollectionCrud from '../../common/Components/CollectionCrud'
import FormulairesCss from './css/FormulairesCss'
import { collectionActions, updateFormulaireMark } from '../../../reducers/collectionsReducer'
import CheckboxInput from "../../common/Components/CheckboxInput"

class Formulaires extends Component {
  state = {
    selectedSejour: null,
  }

  componentDidMount() {
    let {dispatch} = this.props;
    collectionActions(
      dispatch,
      'sejours',
      'SHOW',
      {uuid: this.props.match.params.uuid},
    )

    collectionActions(
      dispatch,
      'signatures',
      'INDEX',
      {params: {sejour_uuid: this.props.match.params.uuid}}
    )
  }

  getTitle() {
    if (this.props.sejoursStore.detail) {
      return 'pour séjour ' + this.props.sejoursStore.detail.libelle
        + ' du ' + this.getDate(this.props.sejoursStore.detail.date_debut)
        + ' au ' + this.getDate(this.props.sejoursStore.detail.date_fin)
    }
    return null
  }

  getDateTime(string) {
    if (!string) {
      return ''
    }
    let date = new Date(string)
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'}
    return date.toLocaleTimeString('fr-FR', options)
  }

  getDate(string) {
    if (!string) {
      return ''
    }
    let date = new Date(string)
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'}
    return date.toLocaleDateString('fr-FR', options)
  }

  signatureLink(line) {
    let p = line.uuid.split('_')
    return '/souhaits/formulaire_' + p[1]
  }

  markClickHandler(line) {
    updateFormulaireMark(
      this.props.dispatch, line.uuid, {
        is_marked: !line.is_marked,
      }
    )
  }

  getActionsButtons(line) {
    const {classes} = this.props

    var btns = []

    btns.push(
      <a
        key="link"
        title="Voir le formulaire signé"
        href={this.signatureLink(line)}
        className={classes.signatureLink}
        target='_blank'
        rel="noopener noreferrer"
      >
        <Visibility/>
      </a>
    )
    return btns
  }

  getMarkButton(line) {
    return (
      <CheckboxInput
          id='is_marked'
          value={line.is_marked}
          name='is_marked'
          onChangeHandler={this.markClickHandler.bind(this, line)}
      />
    )
  }

  render() {
    const {classes} = this.props

    return (
      <Grid container spacing={2} className={classes.container}>
        <Typography
          variant="button"
          gutterBottom
          className={classes.sectionTitle}
        >
          Formulaires signés pour {this.getTitle()}
        </Typography>

        <CollectionCrud
          collectionName={'signatures'}
          loadDatas={false}
          showBtnEdit={false}
          showBtnAdd={false}
          showBtnDelete={false}
          datatableConfig={{
            showPagination: true,
            showSearch: true,
            rowsPerPageOptions: [20, 50, 100],
          }}
          cellsConfig={[
            {
              datakey: 'enfant_nom',
              title: 'Nom enfant',
              sortable: true,
              searchable: true,
            },
            {
              datakey: 'enfant_prenom',
              title: 'Prénom',
              sortable: true,
              searchable: true,
            },
            {
              datakey: 'signature_date',
              title: 'Date signature',
              sortable: true,
              searchable: true,
              format: (obj, key) => {
                return this.getDateTime(obj[key])
              },
            },
            {
              title: 'Marqué',
              format: this.getMarkButton.bind(this),
              sortable: false,
            },
            {
              format: this.getActionsButtons.bind(this),
              sortable: false,
            },
          ]}
        />
      </Grid>
    );
  }
}

Formulaires = withStyles(FormulairesCss)(Formulaires)

Formulaires = connect((store) => {
  return {
    sejoursStore: store.collections.sejours,
    signaturesStore: store.collections.signatures,
  }
})(Formulaires);

export default Formulaires
